const resolveCompound = <T = unknown>({ rawVal }: CompoundProps<T>) => {
  if (!rawVal) return {} as T;

  const [val] = Array.isArray(rawVal) ? rawVal : [rawVal];
  return val || ({} as T);
};

export default resolveCompound;
